<script>
import {nextTick} from 'vue';
import EcommerceForm from '../modules/EcommerceForm';
import swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default {
  props: {
    currentProducts: [],
     slides: 0, 
  },
  data() {
    return {
      currentStep: 1,
      config: {
        productArea: 'Europe',
        isMember: false,
        isPlus: false,
      },
      products: [],
    }
  },

  mounted() {
    this.container = document.querySelector('.js-vue-product-steps');
    this.products = this.currentProducts;
    setTimeout(() => {
     this.swiper = new swiper('.product-swiper', {
        modules: [Pagination],
        slidesPerView: 1.2,
        loop: false,
        spaceBetween: 10,
        enabled: true,
        observer: true,
        breakpoints: {
            750: {
                slidesPerView: 1.3, 
            },
            1000: {
                slidesPerView: Math.min(2.5, this.slides), 
                enabled: Math.min(2.5, this.slides) < this.slides,
            },
            1500: {
                enabled: false,
                slidesPerView: this.slides, 
            }
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            /* type: 'fraction',  */
        },
    }); 
     // Hide pagination when swiper is disabled
    this.updatePaginationVisibility();
    // Listen for breakpoint changes
    this.swiper.on('breakpoint', () => {
       this.updatePaginationVisibility();
    }); 

}, 200);    
    
     
    
  },

  watch: {
    currentStep(val) {
      this.container.scrollIntoView();
    }
  },

  methods: {
    updatePaginationVisibility() {
      if (this.swiper && this.swiper.pagination && this.swiper.pagination.el) {
        if (this.swiper.enabled) {
          this.swiper.pagination.el.style.display = 'block';
        } else {
          this.swiper.pagination.el.style.display = 'none';
        }
      }
    },

    setProductProperties(area, isPlus = 'false') {
        if (!area) {
            return null;
        }
        // Update the area in the config instead of directly selecting a product
        this.config.productArea = area;
        this.config.isPlus = isPlus == 'true' ? true : false;
        
      this.currentStep = 2;
    },


    trackItemSelect(product) {
      const trackingProduct = document.querySelector(`[data-ecommerce-id="${product.id}"]`);
      EcommerceForm.trackItemSelect(trackingProduct);

      document.location.href = product.shop.url;
    },
  },

  computed: {
    selectedProduct() {
      if (!this.products || this.products.length === 0) {
        return null;
      }

      // Filter products based on config values
      const product = this.products.find(product => {
        // Match area from config
        const areaMatch = product.productArea.toLowerCase() === this.config.productArea.toLowerCase();

        // Match membership status
        const membershipMatch = product.isMember === this.config.isMember;

        //Match Product-Type
        const productPlanMatch = product.isPlus === this.config.isPlus;

        // Return product that matches all criteria
        return areaMatch && membershipMatch && productPlanMatch;
      });

      return product;
    },
    getPriceMonthly() {
      if (!this.selectedProduct || !this.selectedProduct.price || !this.selectedProduct.price.includingDiscount) {
        return '0.00';
      }

      // Calculate monthly price (yearly price divided by 12)
      const yearlyPrice = this.selectedProduct.price.includingDiscount;
      const monthlyPrice = yearlyPrice / 12;

      // Format the price with Swiss number format (thousands separator as ')
      return monthlyPrice.toLocaleString('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    getPriceYearly() {
      if (!this.selectedProduct || !this.selectedProduct.price || !this.selectedProduct.price.includingDiscount) {
        return '0.00';
      }

      // Get yearly price
      const yearlyPrice = this.selectedProduct.price.includingDiscount;

      // Format the price with Swiss number format (thousands separator as ')
      return yearlyPrice.toLocaleString('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
  }
}
</script>